import clsx from '@/lib/clsx';

const WizardPanels = ({ children, className = '', ...props }) => {
  return (
    <div className={clsx('comp-wizard-panels', className)} {...props}>
      {children}
    </div>
  );
};

export default WizardPanels;
